import request from "@/utils/request";

// 获取礼包模板列表
export function getGiftListApi(data) {
    return request({
        url: "/admin/comfort_code_template",
        method: "get",
        params: data
    });
}

// 模板添加
export function addGiftTemplateApi(data) {
    return request({
        url: "/admin/comfort_code_template",
        method: "post",
        params: data
    });
}

// 模板修改
// 安抚礼包-修改 - 获取
export function getGiftTemplateApi(data) {
    return request({
        url: "/admin/comfort_code_template/" + data.id,
        method: "get",
        params: data
    });
}
// 安抚礼包-修改 - 提交
export function fixGiftTemplateApi(data) {
    return request({
        url: "/admin/comfort_code_template/" + data.id,
        method: "put",
        params: data
    });
}

// 模板删除
export function deleteGiftTemplateApi(data) {
    return request({
        url: "/admin/comfort_code_template/" + data.id,
        method: "delete",
        params: data
    });
}

// 礼包 获取游戏和类型的下拉 选项
export function getSelectListApi() {
    return request({
        url: "/admin/comfort_code_template_select",
        method: "get",
    });
}

// 礼包码列表
export function getGiftCodeListApi(data) {
    return request({
        url: "/admin/comfort_code",
        method: "get",
        params: data
    });
}

// 安抚礼包-礼包码添加
export function addGiftCodeApi(data) {
    return request({
        url: "/admin/comfort_code",
        method: "post",
        params: data
    });
}

// 安抚礼包-修改 - 获取
export function getGiftCodeContentApi(data) {
    return request({
        url: "/admin/comfort_code/" + data.id,
        method: "get",
        params: data
    });
}
// 安抚礼包-修改 - 提交
export function putGiftCodeContentApi(data) {
    return request({
        url: "/admin/comfort_code/" + data.id,
        method: "put",
        params: data
    });
}

// 安抚礼包-礼包码删除
export function deleteGiftCodeApi(data) {
    return request({
        url: "/admin/comfort_code/" + data.id,
        method: "delete",
        params: data
    });
}

// 安抚礼包-批量修改礼包码内容
export function updateLostGiftCodeApi(data) {
    return request({
        url: "/admin/update_code_content",
        method: "post",
        data
    });
}


// 安抚礼包-领取礼包码
export function receiveGiftCodeApi(data) {
    return request({
        url: "/admin/fetch_comfort_code",
        method: "post",
        params: data
    });
}

// 安抚礼包-领取详情
export function receiveGiftCodeResultApi(data) {
    return request({
        url: "/admin/get_fetch_code_result",
        method: "get",
        params: data
    });
}

// 安抚礼包-获取错误报告
export function getErrorLogApi() {
    return request({
        url: "/admin/downloadErrorLog",
        method: "get",
    });
}
// 发送验证码
export function sendVerificationCode(data) {
    return request({
        url: "/admin/save_verification_code_record",
        method: "post",
        params: data
    });
}
// 验证码列表
export function getVerificationCodeList(data) {
    return request({
        url: "/admin/verification_code_list",
        method: "get",
        params: data
    });
}
// 从运营后台获取用户信息
export function getUserList(data) {
    return request({
        url: "/admin/get_code_info_from_yun",
        method: "get",
        params: data
    });
}
// 验证码发送原因下拉框
export function getVerificationCodeSelect() {
    return request({
        url: "/admin/verification_code_purpose_option",
        method: "get",
    });
}
